import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { MaskIcon } from './Icon';
import { isCurrentUserAdmin } from '../utils/auth';
import './TabBar.css';

function UserIcon() {
  const [initials, setInitials] = useState<string | null>(null);

  useEffect(() => {
    const check = () => {
      try {
        const saved = localStorage.getItem('alterrego_user');
        if (saved) {
          const u = JSON.parse(saved);
          const name = u.name || u.email || '';
          const parts = name.trim().split(/\s+/);
          if (parts.length >= 2) {
            setInitials((parts[0][0] + parts[1][0]).toUpperCase());
          } else if (parts[0]) {
            setInitials(parts[0].substring(0, 2).toUpperCase());
          }
        } else {
          setInitials(null);
        }
      } catch { setInitials(null); }
    };
    check();
    const id = setInterval(check, 1000);
    return () => clearInterval(id);
  }, []);

  if (initials) {
    return <span className="tab-avatar">{initials}</span>;
  }
  return <MaskIcon name="user" size={26} />;
}

// Bottom nav publique : les 5 onglets s'affichent toujours, pour tout le monde
// (public, staff, admin). Le contrôle d'accès staff est géré ailleurs (gardes de
// route RequireAdmin sur /staff/*, cf. App.tsx), pas dans la barre.
const tabs = [
  { to: '/', faIcon: 'store', label: 'Accueil' },
  { to: '/discuter', faIcon: 'comment', label: 'Discuter' },
  { to: '/reserver', faIcon: 'calendar', label: 'Réserver' },
  { to: '/la-carte', faIcon: 'utensils', label: 'La Carte' },
  { to: '/compte', faIcon: null, label: 'Mon compte' },
];

export function TabBar() {
  const navigate = useNavigate();
  const lastTapRef = useRef(0);

  const handleHomeTap = useCallback((e: React.MouseEvent) => {
    const now = Date.now();
    if (now - lastTapRef.current < 400) {
      // Double-tap → staff dashboard (si admin selon backend, pas email).
      // Permet Hide My Email Apple Sign-In : le check email hardcodé loupait
      // les comptes avec relay address `xxxx@privaterelay.appleid.com`.
      if (isCurrentUserAdmin()) {
        e.preventDefault();
        navigate('/staff/dashboard');
      }
      lastTapRef.current = 0;
    } else {
      lastTapRef.current = now;
    }
  }, [navigate]);

  return (
    <nav className="tab-bar">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) => `tab-item ${isActive ? 'active' : ''}`}
          end={tab.to === '/'}
          onClick={tab.to === '/' ? handleHomeTap : undefined}
        >
          <span className="tab-icon">
            {tab.to === '/compte' ? <UserIcon /> : <MaskIcon name={tab.faIcon!} size={26} />}
          </span>
          <span className="tab-label">{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
